DM.Service.ProductFilters = (function () {
    var cache = [];

    return {
        _fetchFromServer: function (url, param) {
            const urlHasQuery = url.indexOf('?') > -1;
            return fetch(url + (urlHasQuery ? '&' : '?') + 'json=' + param).then(response => response.json());
        },
        _fetchFromCache: function (cache, url) {
            return cache.filter(function (item) {
                return item.url === url;
            })[0];
        },
        _addToCache: function (cache, data) {
            return cache.push(data);
        },
        getData: function (url, param) {
            var cached = this._fetchFromCache(cache, url + param);

            return new Promise((resolve, reject) => {
                if (cached) {
                    resolve(cached.data);
                } else {
                    this._fetchFromServer(url, param)
                        .then(function (response) {
                            this._addToCache(cache, {
                                url: url + param,
                                data: response
                            });
                            resolve(response);
                        }.bind(this))
                        .catch(function (error) {
                            reject(error);
                        });
                }
            });
        }
    };
})();
